// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { Lock } from 'lucide-react'

// Display labels for opt-in modules. Keep keys in sync with the backend module catalog.
export const MODULE_LABELS: Record<string, string> = {
  carerx: 'CareRx',
  queues: 'Operation Queues & Custom Views',
  shipping: 'Shipping & Fulfillment',
  insights: 'Insights & Dashboards',
  secure_share: 'Secure Share',
}
export const moduleLabel = (key?: string) => (key && MODULE_LABELS[key]) || 'This module'

/**
 * Professional "locked" panel shown when a pharmacy isn't licensed for a module.
 * Used by the route guard and by settings tabs in place of hiding the feature,
 * so pharmacies can see what's available and who to contact to enable it.
 */
export default function ModuleLocked({ moduleKey, compact }: { moduleKey?: string; compact?: boolean }) {
  const label = moduleLabel(moduleKey)
  return (
    <div
      style={{
        maxWidth: 440,
        margin: compact ? '24px auto' : '64px auto',
        padding: 28,
        textAlign: 'center',
        border: '1px solid var(--color-border)',
        borderRadius: 12,
        background: '#fff',
      }}
    >
      <div
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: 44, height: 44, borderRadius: '50%', background: '#f1f5f9', color: '#64748b',
          marginBottom: 14,
        }}
      >
        <Lock size={20} aria-hidden="true" />
      </div>
      <h2 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 6px', color: 'var(--color-text)' }}>
        {label} isn’t included in your plan
      </h2>
      <p style={{ fontSize: 13.5, lineHeight: 1.55, color: 'var(--color-text-soft)', margin: 0 }}>
        To activate {label} for your pharmacy, please reach out to your account executive for licensing information.
      </p>
    </div>
  )
}
